'use-strict';
const { isset, distinctInArray } = require('@hints/utils/data');
const { isArray } = require('@hints/utils/types');

module.exports = class Protocol {
    /**
     * @param {any} evaluation
     * @param {'ms' | 'mr'} gender
     * @param {number} age 
     * @param {any} data
     * @returns {{ score: number, data: any }} data
     */
    getScore(evaluation, gender, age, data) {
        return {
            score: 0,
            data: {}
        };
    }

    validateResults(body) {
        if(!isset(body)) return false;
        if(!isset(body.score)) return false;
        if(body.score < 0 || body.score > 100) return false;
        return true;
    }

    /**
     * Multiple choice factor questions: an empty array means "none of these factors apply".
     * @param {string[]} values 
     * @param {string[]} allowedFactors 
     */
    validateFactors(values, allowedFactors) {
        if(!isArray(values)) return false;
        if(distinctInArray(values).length !== values.length) return false;
        if(values.some(v => !allowedFactors.includes(v))) return false;
        return true;
    }
};
